module.exports = __webpack_public_path__ + "static/media/anatomia.b91db52b.png";